import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    template: require('./checkAccountNumberHelper.html')
})

export class CheckAccountNumberHelperDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<CheckAccountNumberHelperDialog>) public dialogRef: MatDialogRef<CheckAccountNumberHelperDialog>) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }

}
